/**
 * OptionListPicker — inline searchable list used instead of dropdowns
 * in flows Apple reviews on iPad (App Review 2.1(a): both native
 * <select> and portal-based dropdowns proved unreliable in WKWebView).
 * Plain buttons + onClick: nothing to break on any device.
 */
import React, { useState } from "react";
import { MagnifyingGlassIcon as MagnifyingGlass } from "@phosphor-icons/react";

export default function OptionListPicker({ options, value, onChange, placeholder = "Search…", testId, maxHeight = "max-h-52" }) {
  const [q, setQ] = useState("");
  const filtered = q
    ? options.filter(([, label]) => label.toLowerCase().includes(q.toLowerCase()))
    : options;
  return (
    <div className="rounded-lg border border-[#E5E5E5] bg-white overflow-hidden" data-testid={testId}>
      <div className="flex items-center gap-2 px-3 border-b border-[#EFEFEF]">
        <MagnifyingGlass size={14} className="text-[#9CA3AF] flex-shrink-0" />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={placeholder}
          className="w-full py-2.5 text-sm outline-none bg-transparent"
          data-testid={testId ? `${testId}-search` : undefined}
        />
      </div>
      <div className={`overflow-y-auto ${maxHeight}`} role="listbox">
        {filtered.map(([code, label]) => (
          <button
            key={code}
            type="button"
            role="option"
            aria-selected={value === code}
            onClick={() => onChange(code)}
            data-testid={testId ? `${testId}-option-${code}` : undefined}
            className={`w-full text-left px-3 py-2.5 text-sm transition-colors ${
              value === code
                ? "bg-ink text-white font-semibold"
                : "hover:bg-[#FAFAFA] text-[#3F3F3F]"
            }`}
          >
            {label}
          </button>
        ))}
        {filtered.length === 0 && (
          <p className="px-3 py-3 text-xs text-[#9CA3AF]">No matches — try a different spelling</p>
        )}
      </div>
    </div>
  );
}
